(function (angular) {
    var ZoomController = (function () {
        function ZoomController() {
            this.init.apply(this, arguments);
        }

        ZoomController.prototype = {
            init: function ($scope, $element, $ionicScrollDelegate, $timeout, $message) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$element = $element;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$timeout = $timeout;
                this.$message = $message;


                this.isReady = false;
                this.delegateHandel = _.uniqueId("delegate-handel-");
                this.getImageDimension(this.$scope.attachment, function (dimension) {
                    this.originDimension = dimension;

                    //Update attachment
                    this.$scope.attachment.dimension = dimension;
                    this.$scope.attachment.loaded = true;

                    this.ready();

                    this.isReady = true;

                    this.safeApply();
                });
            },
            /**
             * The control is ready html
             */
            ready: function () {
                //Init minZoom,maxZoom
                var dimension = this.imageDimension,
                    maxZoom = this.getMaxZoom(dimension);
                this.minZoom = 1 / maxZoom;
                this.maxZoom = 1;

                //Init scroller
                var scrollerView = this.getScrollerView();
                scrollerView.options.zooming = true;
                scrollerView.options.minZoom = this.minZoom;
                scrollerView.options.maxZoom = this.maxZoom;
                scrollerView.options.scrollingComplete = angular.bind(this, this.onScroll);



                //Calc position
                this.imageDimension = this.fixLargeImage(this.originDimension);
                this.render();

                //Zoom to min
                var scroller = this.getScroller();
                scroller.zoomTo(this.minZoom, false, 0, 0);


                //Show image after 100ms
                var _this = this;
                this.$timeout(function () {
                    _this.$element.find(".img").addClass("visibility-visible");
                }, 100);


                this.bindEvents();


  

            },
            bindEvents: function () {
                //Fix scroll if swipe left to right to back
                this.$element.bind("touchmove.test", function (ev) {
                    if (ev.originalEvent.touches[0].pageX < 0) {
                        ev.stopImmediatePropagation();
                    }
                });

                this.$scope.swiper.on('resize', angular.bind(this, function () {
                    this.resize();
                }));


       
                this.$scope.swiper.on('slideChangeTransitionEnd', angular.bind(this, function () {
                    if (this.$scope.swiper.previousIndex === this.$scope.slideIndex) {
                        this.getScroller().zoomTo(this.minZoom, false, 0, 0);
                    }
                }));


            },
            resize: function () {

                //Calc demension
                this.imageDimension = this.fixLargeImage(this.originDimension);

                //Calc position
                this.render();

                //Zoom to min
                var scroller = this.getScroller();
                scroller.scrollTop();
                scroller.zoomTo(this.minZoom, false, 0, 0);

                //Allow swiper
                this.$scope.swiper.allowTouchMove = true;


            },
            render: function () {
                var dimension = this.imageDimension,
                    maxZoom = this.getMaxZoom(dimension),
                    top = (this.$element.height() / 2) - (dimension.height * this.minZoom) / 2,
                    left = (this.$element.width() / 2) - (dimension.width * this.minZoom) / 2;
                this.$element.find(".scroller-content").css({
                    'width': this.$element.width() * maxZoom,
                    'height': this.$element.height() * maxZoom
                });
                this.$element.find(".img-container").css({
                    'top': top * maxZoom,
                    'bottom': top * maxZoom,
                    'left': left * maxZoom,
                    'right': left * maxZoom,
                    'width': dimension.width,
                    'height': dimension.height
                });
            },
            getMaxZoom: function () {
                return 3;
            },
            getImageDimension: function (attachment, callback) {
                var _this = this;
                if (this.$scope.attachment.dimension) {
                    this.$timeout(function () {
                        callback.apply(_this, [_this.$scope.attachment.dimension]);
                    }, 500);
                }
                else {
                    var img = new Image();
                    img.onload = function () {
                        callback.apply(_this, [{
                            width: img.width,
                            height: img.height
                        }]);
                        img = null;
                    };
                    img.onerror = angular.bind(this, function () {
                        this.$message.error("Can't load image.");
                    });
                    img.src = this.$scope.attachment['DownloadUrl'];
                }
            },
            fixLargeImage: function (dimension) {
                var scale = this.getMaxZoom();
                var $width = dimension.width,
                    $height = dimension.height,
                    width = this.$element.width(),
                    height = this.$element.height(),
                    scale1 = $width / width,
                    scale2 = $height / height;
                if (scale1 > scale2) {
                    height = dimension.height * (1 / scale1);
                }
                else {
                    width = dimension.width * (1 / scale2);
                }
                return {
                    width: width * scale,
                    height: height * scale
                };
            },
            safeApply: function (fn) {
                var phase = this.$scope.$root.$$phase;
                if (phase === '$apply' || phase === '$digest') {
                    if (fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$scope.$apply(fn);
                }
            },
            getScroller: function () {
                return _.find(this.$ionicScrollDelegate['_instances'], function (instance) {
                    return instance.$element[0].id === this.delegateHandel;
                }, this);
            },
            getScrollerView: function () {
                return this.getScroller().getScrollView();
            },
            zoom: function (pageX, pageY) {
                var originLeft = pageX,
                    originTop = (pageY - this.$element.offset().top) - this.getScroller().getScrollPosition().top,
                    zoom = this.getCurrentZoom();
                this.getScroller().zoomTo(zoom, true, originLeft, originTop);
            },
            getCurrentZoom: function () {
                var scrollerView = this.getScrollerView(),
                    zoom = scrollerView.getValues().zoom;
                if (zoom < this.maxZoom / 2)
                    zoom = this.maxZoom;
                else
                    zoom = this.minZoom;
                return zoom;
            },
            onScroll: function () {
                var scrollerView = this.getScrollerView(),
                    zoom = scrollerView.getValues().zoom;
                this.$scope.swiper.allowTouchMove = zoom - this.minZoom <= 0.1;
            },
            onDoubleTap:function($event){
                // Only access this feature app is ready to void error
                if(!this.isReady){
                    return;
                }
                var touchX =  $event.gesture.center.pageX,
                    touchY =  $event.gesture.center.pageY;
                this.zoom(touchX, touchY);
            }
        }
        ;
        ZoomController.$inject = ['$scope', '$element', '$ionicScrollDelegate', '$timeout', '$message'];
        return ZoomController;
    }());

    angular.module('shared').directive('nfZoom', function () {
        return {
            restrict: 'E',
            controller: ZoomController,
            templateUrl: 'js/shared/directives/zoom/zoom.html',
            scope: {
                swiper: "=",
                attachment: "=",
                slideIndex: '='
            }
        };
    });
}(angular));